'use client'

import { type Tag, TagInput } from 'emblor'
import { useState } from 'react'
import type { AutoFormWidgetsProps } from '../autoForm'
import { Field } from '../field'
import { FieldControl } from '../fieldControl'
import { FieldLabel } from '../label'
import { FieldMessage } from '../message'

export const TagsWidget = (props: AutoFormWidgetsProps) => {
  const initalList =
    typeof props.initialValue !== 'string' ? props.initialValue : [props.initialValue]

  const [tags, setTags] = useState<Tag[]>(
    (initalList || []).map((item: string) => ({ id: item, text: item })) || [],
  )
  const [activeTagIndex, setActiveTagIndex] = useState<number | null>(null)

  return (
    <Field path={props.path} className={props.classNames?.root}>
      <FieldLabel>{props.options?.label as string}</FieldLabel>

      <FieldControl>
        <select multiple className="hidden" value={tags.map((t) => t.text)} onChange={() => {}}>
          {tags.map((tag) => (
            <option key={tag.id} value={tag.text} />
          ))}
        </select>
      </FieldControl>
      <TagInput
        placeholder={props.options?.placeholder as string}
        tags={tags}
        setTags={setTags}
        activeTagIndex={activeTagIndex}
        setActiveTagIndex={setActiveTagIndex}
        styleClasses={{
          inlineTagsContainer: 'shadow',
        }}
      />
      <FieldMessage />
    </Field>
  )
}
